import { Link, useLocation, useParams } from 'react-router-dom';

type IframeContentState = {
    iframeContent: string
}

export default function IFrameNav() {
    let params = useParams();
    const { state } = useLocation();
    const iFrameUrl = state as IframeContentState;
    const IframeUrl = () => {
        let url = "";

        switch(iFrameUrl?.iframeContent) {
            case("infosite"):
                url = 'https://www.1881.no/tlf/mkas_' + params.id;
                break;
            case("statistics"):
                url = `https://statistikk.1881.no/KundeRapport/${params.id}?showmonth=3`
                break;
            default:
                url = '';
                break;
        }

        return (
            <a href={url} className="link-light" target="_parent">Lukk ramme <i className="bi bi-x-lg"></i></a>
        );
        
    }
    return(
        <nav className="navbar fixed-top navbar-dark" style={{background: '#003a66'}}>
            <div className="container-fluid">
                <Link to={'..'} className='link-light'><i className="bi bi-arrow-left"></i> Min bedrift</Link>
                <IframeUrl />
            </div>
        </nav>
    )
}